import { render, staticRenderFns } from "./DatosPersonalesCard.vue?vue&type=template&id=5145dfe0"
import script from "./DatosPersonalesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosPersonalesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports